// src/pages/sangamam/bookVisitButton.jsx
import React from "react";
import "./bookVisitButton.css";

/**
 * Sticky "Book you site visit" button — used ONLY on the
 * Thiruporur/Sangamam page. Stays fixed to the right edge of the
 * viewport while scrolling, and clicking it scrolls down to the
 * enquiry form rendered in the footer (id="sangamam-contact-form",
 * see contactForm.jsx).
 */
const BookVisitButton = () => {
  const handleClick = () => {
    const formEl = document.getElementById("sangamam-contact-form");
    if (formEl) {
      formEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <button
      type="button"
      className="sangamam-sticky-visit-btn"
      onClick={handleClick}
    >
      Book you site visit
    </button>
  );
};

export default BookVisitButton;
